document.addEventListener('DOMContentLoaded', function () {
  const isMobile = window.innerWidth <= 768;
  let productGrid = isMobile
    ? document.getElementById('mobile-product-grid')
    : document.getElementById('product-grid');
  
  let hollyGrid = document.getElementById('holly-grid');
  let isGridLayout = false;

  // Check initial layout state
  checkLayoutMode();

  if (!productGrid && !hollyGrid) return;

  const loadingSpinner = document.createElement('div');
  loadingSpinner.className = 'loading-spinner';
  loadingSpinner.style.display = 'none';
  
  // Insert spinner after the appropriate container
  const activeContainer = getCurrentActiveContainer();
  if (activeContainer) {
    activeContainer.parentNode.insertBefore(loadingSpinner, activeContainer.nextSibling);
  }

  const urlParams = new URL(window.location.href).searchParams;
  let currentPage = parseInt(urlParams.get('page')) || 1;

  let isLoading = false;
  let hasMorePages = true;

  function checkLayoutMode() {
    hollyGrid = document.getElementById('holly-grid');
    if (hollyGrid) {
      const hollyGridContainer = document.getElementById('holly-grid-container');
      if (hollyGridContainer) {
        // Check if the element is visible (not hidden by Alpine.js)
        const computedStyle = window.getComputedStyle(hollyGridContainer);
        const isVisible = computedStyle.display !== 'none' && hollyGridContainer.style.display !== 'none';
        isGridLayout = isVisible;
        //console.log('Holly Grid Layout Check:', { isVisible, display: computedStyle.display, style: hollyGridContainer.style.display });
      } else {
        // Fallback: check if holly-grid itself is visible
        const computedStyle = window.getComputedStyle(hollyGrid);
        isGridLayout = computedStyle.display !== 'none';
        //console.log('Holly Grid Fallback Check:', { isVisible: isGridLayout, display: computedStyle.display });
      }
    } else {
      isGridLayout = false;
      //console.log('Holly Grid not found, using product grid');
    }
  }

  function getCurrentActiveContainer() {
    checkLayoutMode();
    setNewProductGrid();
    
    if (isGridLayout && hollyGrid) {
      return hollyGrid;
    }
    return productGrid;
  }

  function loadMoreProducts() {
    if (isLoading || !hasMorePages) return;
    
    const activeContainer = getCurrentActiveContainer();
    if (!activeContainer) return;

    //console.log('Loading more products...', { isGridLayout, activeContainer: activeContainer.id });

    isLoading = true;
    loadingSpinner.style.display = 'block';
    activeContainer.parentNode?.insertBefore(loadingSpinner, activeContainer.nextSibling);
   
    const nextPage = currentPage + 1;
    const url = new URL(window.location.href);
    url.searchParams.set('page', nextPage);
    url.searchParams.set('section_id', activeContainer.dataset.id);

    fetch(url)
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        
        if (isGridLayout && hollyGrid) {
          //console.log('Using Holly Grid layout for infinite load');
          loadMoreForHollyGrid(doc, activeContainer);
        } else {
          //console.log('Using Product Grid layout for infinite load');
          loadMoreForProductGrid(doc, activeContainer);
        }
      })
      .catch(error => {
        console.error('Error loading more products:', error);
      })
      .finally(() => {
        isLoading = false;
        loadingSpinner.remove();
      });
  }

  function loadMoreForProductGrid(doc, activeContainer) {
    const newProducts = doc.getElementById(activeContainer.id)?.innerHTML;

    if (newProducts && newProducts.trim()) {
      activeContainer.insertAdjacentHTML('beforeend', newProducts);
      currentPage++;

      const newUrl = new URL(window.location.href);
      newUrl.searchParams.set('page', currentPage);
      window.history.replaceState({}, '', newUrl);

      if (window.reinitProductCards) {
        window.reinitProductCards();
      }
    } else {
      hasMorePages = false;
    }
  }

  function loadMoreForHollyGrid(doc, activeContainer) {
    const newHollyGrid = doc.getElementById('holly-grid');
    
    if (newHollyGrid) {
      // Extract only the product links from the new grid
      const newProducts = newHollyGrid.querySelectorAll('a[href*="/products/"]');
      
      //console.log('Holly Grid: Found', newProducts.length, 'new products');
      
      if (newProducts && newProducts.length > 0) {
        // Append new products to the existing grid
        newProducts.forEach(productLink => {
          activeContainer.appendChild(productLink);
        });
        
        currentPage++;

        const newUrl = new URL(window.location.href);
        newUrl.searchParams.set('page', currentPage);
        window.history.replaceState({}, '', newUrl);
        
        //console.log('Holly Grid: Successfully loaded', newProducts.length, 'products on page', currentPage);
      } else {
        hasMorePages = false;
        //console.log('Holly Grid: No more products to load');
      }
    } else {
      hasMorePages = false;
      //console.log('Holly Grid: No holly-grid found in response');
    }
  }

  function handleScroll() {
    const scrollPosition = window.innerHeight + window.scrollY;
    
    const activeContainer = getCurrentActiveContainer();
    if (!activeContainer) return;
    
    const containerBottom = theme.getOffsetTopFromDoc(activeContainer) + activeContainer.offsetHeight;
    const threshold = containerBottom - (isMobile ? 800 : 600);

    if (scrollPosition > threshold) {
      loadMoreProducts();
    }
  }

  function setNewProductGrid(){
    productGrid = isMobile
      ? document.getElementById('mobile-product-grid')
      : document.getElementById('product-grid');
    
    hollyGrid = document.getElementById('holly-grid');
  }

  // Listen for layout changes by observing style changes on the holly-grid container
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
        checkLayoutMode();
      }
    });
  });

  // Observe the container that shows/hides based on layout
  const hollyGridContainer = document.getElementById('holly-grid-container');
  if (hollyGridContainer) {
    observer.observe(hollyGridContainer, { attributes: true });
  }

  // Also listen for clicks on layout switcher buttons to detect layout changes
  document.addEventListener('click', function(e) {
    if (e.target.closest('#layout-switcher button')) {
      setTimeout(checkLayoutMode, 100); // Small delay to allow Alpine.js to update
    }
  });

  window.addEventListener('scroll', handleScroll);
});